<template>
  <div
    :class="bem()"
  >
    <div :class="bem('user')">
      <div
        :class="bem('profile-picture')"
      >
        <DatoCmsImage
          :data="props.item.profilePicture.responsiveImage"
          object-fit="cover"
          :object-position="`${props.item.profilePicture.focalPoint.x * 100}% ${
            props.item.profilePicture.focalPoint.y * 100
          }%`"
          layout="fill"
          sizes="(max-width: 1280px) 100vw, 40vw"
        />
      </div>
      <div :class="bem('user-titles')">
        <VisionHeading
          v-if="props.item.name"
          tag="h6"
          size="h5"
        >
          {{ props.item.name }}
        </VisionHeading>
        <h6
          v-if="props.item.username"
          :class="bem('detail-text', {'grey': true})"
        >
          {{ props.item.username }}
        </h6>
      </div>
      <VisionIcon
        :icon="props.item.platform"
        colour="black"
        size="x-small"
      />
    </div>
    <div :class="bem('main')">
      <p
        :class="bem('quote')"
      >
        {{ props.item.quote }}
      </p>
    </div>
    <h6
      v-if="props.item.date"
      :class="bem('detail-text', {'grey': true})"
    >
      {{ $dayjs(props.item.date).format('MMMM YYYY') }}
    </h6>
  </div>
</template>

<script setup lang="ts">
import { Image as DatoCmsImage } from 'vue-datocms'

const bem = useBEM('CredibilitySocial')

const props = defineProps({
  item: { type: Object, required: true }
})

</script>

<style lang="postcss">
.CredibilitySocial {
  @apply flex flex-col gap-3
  justify-between items-stretch
  py-6 px-5 pb-8 rounded-lg
  bg-grey-200;
}

.CredibilitySocial__main {
  @apply flex flex-col gap-3;
}

.CredibilitySocial__user {
  @apply flex gap-3 justify-between items-center;
}

.CredibilitySocial__user-titles {
  @apply flex-grow;
}

.CredibilitySocial__profile-picture {
  @apply relative w-8 h-8
  flex items-center justify-center
  rounded-full overflow-clip;
}

.CredibilitySocial__detail-text {
  @apply text-xs;

  &--grey {
    @apply text-mid-grey;
  }
}
</style>